import React from 'react';
import ProductCard from './ProcuctionCard';
import '../styles/ProductList.css';
import { ItemDTO } from '../dto/item/ItemDTO';

type ProductListProps = {
  products: ItemDTO[];
};

const ProductList: React.FC<ProductListProps> = ({ products }) => {
  return (
    <div className="product-list">
      {products.map((item) => (
        <ProductCard
          key={item.id}
          id={item.id}
          title={item.name}
          price={item.price}
          sale={item.sale}
          imageUrl={item.thumbnail}
          currency={item.currency}
        />
      ))}
    </div>
  );
};

export default ProductList;
